import { useEffect, useState } from "react";
import Table from "../../../../components/Table";
import MaterialTypography from "../../../../components/MaterialTypography";
import { Card, CardHeader, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MaterialButton from "../../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { FileUpload, FilterAlt } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { deleteData, fetchData, postData } from "../../../../services";
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index";
import UploadFile from "../../../Utils/UploadFile";
import { useSnackbar } from "../../../../context/popup";
import { setCircleLoading } from "../../../../components/Loading";
import MakeFilterDialog from "./component/MakeFilterDialog";

const InsurerMake = ({tabState}) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [isRefresh, setIsRefresh] = useState(false);
  const { showSnackbar } = useSnackbar();

  //dialogstate
  const [openUploadFileDialog, setOpenUploadFileDialog] = useState(false);
  const [fileUploading, setFileUploading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [clearFileOnSuccess, setClearFileOnSuccess] = useState(false);
  const currentPage = useSelector(
    (state) => state?.insurerMakeReducer?.currentPage
  );
  const rowsPerPage = useSelector(
    (state) => state?.insurerMakeReducer?.rowsPerPage
  );
  const totalPages = useSelector(
    (state) => state?.insurerMakeReducer?.totalPages
  );

  const [makeData, setMakeData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [filterData, setFilterData] = useState({
    isActive: "",
  });

  const fetchMakeData = async () => {
    setCircleLoading(true);
    try {

      let url = `/reference/insurer/make?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`;
      //for active and inactive status
      if(filterData.isActive !== "") {
          url += `&isActive=${filterData.isActive}`;
      }

      const response = await fetchData(url);
      const successResponse = response?.success;
      if (successResponse) {
        setMakeData(response?.data?.items);
      } else {
        showSnackbar("Failed to fetch data","error");
      }
      dispatch(setTotalPages(response?.data?.totalPages));
    } catch (error) {
      console.error("Error fetching data:", error);
      showSnackbar(error?.response?.data?.message, "error");
    } finally {
      setCircleLoading(false);
    }
  };

  const handleSearch = (value) => {
    setSearch(value);
  };

  useEffect(() => {
    if(tabState === "make"){
      fetchMakeData();
    }
  }, [isRefresh, currentPage, rowsPerPage, search]);

  const columns = [
    {
      key: "sno",
      label: "S.No",
      renderCell: (row) => row.sno,
    },
    {
      key: "name",
      label: "Make Name",
      renderCell: (row) => row.name,
    },
    {
      key: "createdAt",
      label: "Created At",
      renderCell: (row) => new Date(row.createdAt).toLocaleDateString('en-IN'),
    },
    {
      key: "active",
      label: "Status",
      renderCell: (row) => (
        <span>
          {row.isActive ? (
            <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
          ) : (
            <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
          )}
        </span>
      ),
    },
  ];

  const rows = makeData.map((make, index) => ({
    ...make,
    sno: index + 1,
  }));

  const handlePaginationChange = (page) => {
    dispatch(setCurrentPage(page));
  };

  const handleRowsPerPageChange = (rowsPerPage) => {
    dispatch(setRowsPerPage(rowsPerPage));
    dispatch(setCurrentPage(1));
  };

  const handleEdit = (row) => {
    navigate(
      `/insurer-master/insurer-motor-mmv/add-insurer-make?pageType=edit&id=${row.id}`
    );
  };

  const handleView = (row) => {
    navigate(
      `/insurer-master/insurer-motor-mmv/add-insurer-make?pageType=view&id=${row.id}`
    );
  };

  const handleDelete = async (row) => {
    try {
      const response = await deleteData(`/motor/mmv/make-delete`, {
        ids: [row?.id],
      });
      setIsRefresh(!isRefresh);
      if (response?.success) {
        showSnackbar(response?.message,"success");
      } else {
        showSnackbar("Failed to delete Motor Make","error");
      }
    } catch (error) {
      console.error("Error deleting data:", error);
      showSnackbar(error?.response?.data?.message, "error");
    }
  };

  const actions = {
    edit: true,
    view: true,
    delete: true,
    onEdit: (row) => handleEdit(row),
    onView: (row) => handleView(row),
    onDelete: (row) => handleDelete(row),
  };

  const handleAddNewMake = () => {
    navigate("/insurer-master/insurer-motor-mmv/add-insurer-make");
  };

  //bulk file upload api function
  const handleFileUploadSuccess = async (file) => {
    setFileUploading(true);
    setUploadSuccess(false);

    try {
      const formData = new FormData();

      formData.append("file", file);

      const result = await postData(
        `/motor/insurer/bulkUpload/insurer-make`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (result?.success) {
        setUploadSuccess(true);
        showSnackbar(result?.message, "success");
        setOpenUploadFileDialog(false);
        setClearFileOnSuccess(true);
        fetchMakeData();
      } else {
        setUploadSuccess(false);
        showSnackbar("Faiiled to upload file", "error");
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      console.error("Upload error:", error || errorMessage);
      showSnackbar(errorMessage, "error");
    } finally {
      setFileUploading(false);
    }
  };

  return (
    <div>
      {/* <DashboardLayout> */}
      <CardHeader
        title={
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Stack direction="column" spacing={0}>
              <MaterialTypography variant="h5" fontWeight="medium">
                Insurer Make management list
              </MaterialTypography>
              <MaterialTypography variant="caption" color="text">
                List of Insurer make that you can get details of motor make.
              </MaterialTypography>
            </Stack>

            <Stack direction="row" spacing={1}>
              <MaterialButton
              variant="gradient"
              color="dark"
              size="small"
              startIcon={<FilterAlt/>}
              onClick={(event) => setAnchorEl(event.currentTarget)}
              >
                  Filter
              </MaterialButton>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<FileUpload />}
                onClick={() => setOpenUploadFileDialog(true)}
              >
                Bulk Upload
              </MaterialButton>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleAddNewMake()}
              >
                Add Make
              </MaterialButton>
            </Stack>
          </Stack>
        }
      />
      <Card sx={{ mx: 1 }}>
        <Table
          columns={columns}
          data={rows}
          actions={actions}
          pagination={{
            totalPages,
            currentPage,
            onPageChange: (page) => handlePaginationChange(page),
            rowsPerPage,
            onRowsPerPageChange: (rowsPerPage) =>
              handleRowsPerPageChange(rowsPerPage),
            rowsPerPageOptions: [5, 10, 15, 20],
          }}
          getRowKey={(row) => row.id}
          className="custom-table"
          noDataLabel={"No Insurer Make data found"}
          handleSearch={handleSearch}
        />
      </Card>
      {/* </DashboardLayout> */}

      <UploadFile
        open={openUploadFileDialog}
        setOpen={setOpenUploadFileDialog}
        onUploadSuccess={handleFileUploadSuccess}
        fileTypes={["csv", "xlsx"]}
        fileUploading={fileUploading}
        uploadSuccess={uploadSuccess}
        setUploadSuccess={setUploadSuccess}
        setFileUploading={setFileUploading}
        clearFileOnSuccess={clearFileOnSuccess}
      />      
      <MakeFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
            setAnchorEl(null);   // close popup
            fetchMakeData();  // call API after filter applied
        }}
        />
    </div>
  );
};

export default InsurerMake;
